module.exports = __webpack_public_path__ + "static/media/Dionysus.9d712082.jpg";